export const tokensOverflow = {
  overflow: {
    hidden: 'hidden',
  },
};
